import React from 'react';
import PropTypes from 'prop-types';
import styles from './Board.module.css';
import Cell from './Cell';

const ColumnGame = ({ column, index }) => {
    return (
        <div className={styles.column} key={`col-${index}`}>
            <ul>
                {column.map((space, i) => (
                    <li key={`cell-${index}-${i}`}>
                        <Cell played={space} />
                    </li>
                )).reverse()}
            </ul>
        </div>
    );
};

ColumnGame.propTypes = {
    column: PropTypes.arrayOf(PropTypes.oneOf([0, 'r', 'b'])).isRequired,
    index: PropTypes.number.isRequired,
};

export function Board({ game }) {
    return (
        <div 
            className={styles.board}
            role="grid"
            aria-label="Connect Four game board"
        >
            {game.map((column, index) => (
                <ColumnGame 
                    key={`column-${index}`}
                    column={column} 
                    index={index} 
                />
            ))}
        </div>
    );
}

Board.propTypes = {
    game: PropTypes.arrayOf(
        PropTypes.arrayOf(PropTypes.oneOf([0, 'r', 'b']))
    ).isRequired,
};